import { render, staticRenderFns } from "./homeIntroduce.vue?vue&type=template&id=4d565894&scoped=true&"
var script = {}
import style0 from "./homeIntroduce.vue?vue&type=style&index=0&id=4d565894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d565894",
  null
  
)

export default component.exports